import { render } from "./ErrorView.vue?vue&type=template&id=53491e72"
import script from "./ErrorView.vue?vue&type=script&lang=js"
export * from "./ErrorView.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__